import { lazy } from 'react';

/**
 * The platform screens, lazily loaded like every route.
 *
 * <p>Declared here rather than beside the others in `routes.tsx` so the router file does
 * not grow four more fast-refresh warnings; and they are a chunk most users -- everyone
 * who is not a platform administrator -- never download at all.
 */
export const OrganizationsPage = lazy(() => import('./OrganizationsPage'));
export const OrganizationDetailPage = lazy(() => import('./OrganizationDetailPage'));
export const PlansPage = lazy(() => import('./PlansPage'));
export const PlatformAdminsPage = lazy(() => import('./PlatformAdminsPage'));
